// @flow

import React from 'react';
import styler from 'react-styling';

type Props = {
  size?: 'small' | 'medium' | 'large',
  style?: Object,
}

const sizes = {
  small: 50,
  medium: 100,
  large: 200,
};


function _createStyle(props) {
  return styler `
    Spinner
      position: absolute
      top: 0
      right: 0
      bottom: 0
      left: 0
      margin: auto
      border-radius: 50%
      width: ${props.size ? sizes[props.size] : sizes.medium}px
      height: ${props.size ? sizes[props.size] : sizes.medium}px
      border: 8px solid rgba(73, 123, 235,0.2)
      border-top-color: rgba(73, 123, 235,1)
      animation: spin 1s infinite linear
      z-index: 1
    `;
}

const Spinner = (props: Props) => {
  const spinnerStyle = _createStyle(props);
  return (
    <div
      style={{ ...spinnerStyle.Spinner, ...props.style }}
    >
      {''}
    </div>
  );
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/js/Components/Spinner.js